/** ISO-8601 week (Monday start). Same Thursday rule as the timesheet. */

export interface IsoWeek {
  week: number;
  year: number;
}

export function isoWeekOf(date: Date): IsoWeek {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const year = d.getUTCFullYear();
  const yearStart = new Date(Date.UTC(year, 0, 1));
  const week = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  return { week, year };
}

/** Monday–Sunday of the ISO week that contains `date`, at local noon. */
export function isoWeekDates(date: Date): Date[] {
  const monday = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
  const day = monday.getDay();
  monday.setDate(monday.getDate() + (day === 0 ? -6 : 1 - day));
  return Array.from({ length: 7 }, (_, index) => {
    const next = new Date(monday);
    next.setDate(monday.getDate() + index);
    return next;
  });
}

const shortMonth = (date: Date) => date.toLocaleDateString('en-GB', { month: 'short' });

/** Compact span under the day row, always including the ISO week-year when it is the only year. */
export function formatWeekSpan(days: Date[], isoYear: number): string {
  const start = days[0];
  const end = days[6];
  if (start.getFullYear() !== end.getFullYear()) {
    return `${start.getDate()} ${shortMonth(start)} ${start.getFullYear()} – ${end.getDate()} ${shortMonth(end)} ${end.getFullYear()}`;
  }
  if (start.getMonth() !== end.getMonth()) {
    return `${start.getDate()} ${shortMonth(start)} – ${end.getDate()} ${shortMonth(end)} ${isoYear}`;
  }
  return `${start.getDate()}–${end.getDate()} ${shortMonth(start)} ${isoYear}`;
}
